import moment = require("moment");
import React = require("react");
import {ReactNode} from "react";
import {JSONTablePageTexts} from "../../CoffeeMachineDashboard";
import {
    BoilerServicesPressureAvg,
    DispensingAvgTime,
    FluxAvg,
    GroupTemperatureAvg,
    PressureAvg,
} from "../../LavazzaGoodnessRanges";
import {PageLoader} from "../PageLoader";
import {RangeGoodnessElement} from "../RangeGoodnessElement";

interface WidgetProps {
    totalTablePage: number;
    currentPage: number;
    changePage: (page: number) => void;
    tableData: TableRow[];
    consumedCoffee: number;
    consumedWater: number;
    texts: JSONTablePageTexts;
    selectedGroup: number;
    onGroupChange: (group: number) => void;
    totalCoffeeGroups: number;
    showSalesData: boolean;
}

interface TableRow {
    date: string;
    boilerTemperature: number;
    dispensingGroup: number;
    dispensingTime: number;
    temperature: number;
    waterFlowSpeed: number;
    boilerServicesPressure: number;
    pumpPressure: number;
    productVariantTypeName: string;
    consumptionType: string;
}

export class TableHistoricConsumptions extends React.Component<WidgetProps, any> {

    constructor(props: WidgetProps) {
        super(props);
    }

    public render(): ReactNode {
        if (this.props.totalTablePage === 0) {
            return null;
        }
        let consumedCoffee = this.props.texts.notDefined;
        let consumedWater = this.props.texts.notDefined;
        if (this.props.consumedCoffee != null) {
            consumedCoffee = this.props.consumedCoffee.toFixed(2) + " KG";
        }
        if (this.props.consumedWater != null && this.props.consumedWater > 0) {
            consumedWater = this.props.consumedWater.toFixed(2) + " L";
        }
        let tableContent = null;
        if (this.props.tableData != null && this.props.tableData.length > 0) {
            tableContent = (
                <>
                    {
                        this.renderItem()
                    }
                </>
            )
            ;
        } else {
            tableContent = (
                <div className="no-data-text-container">
                    <p>{this.props.texts.noDataAvailable}</p>
                </div>
            );
        }
        let groupFilterSelect = null;
        if (this.props.totalCoffeeGroups && this.props.totalCoffeeGroups > 0) {
            const onChange = (event) => {
                this.props.onGroupChange(parseInt(event.target.value, 10));
            };
            const options: JSX.Element[] = [];
            options.push(<option value={-1} key={-1}>{this.props.texts.allGroups}</option>);
            for (let i = 0; i < this.props.totalCoffeeGroups; i++) {
                options.push(<option value={i + 1} key={i}> {this.props.texts.dispensingGroup} {i + 1}</option>);
            }
            groupFilterSelect = (
                <select className="groupFilterSelect" onChange={onChange} value={this.props.selectedGroup}>
                    {options}
                </select>
            );
        }
        return (
            <div className="historic-table-consumptions-widget">
                <div className="table-header">
                    <div className="table-header__content">
                        <div className="col header-col col-1">{this.props.texts.date}</div>
                        <div className="col header-col col-2">{this.props.texts.hour}</div>
                        <div className="col header-col col-3">
                            {groupFilterSelect}
                        </div>
                        <div className="col header-col col-4">{this.props.texts.dispensingTime}</div>
                        <div className="col header-col col-5">{this.props.texts.temperature}</div>
                        <div className="col header-col col-6">{this.props.texts.boilerPressure}</div>
                        <div className="col header-col col-7">{this.props.texts.waterFlowSpeed}</div>
                        <div className="col header-col col-8">{this.props.texts.pumpPressure}</div>
                        <div className="col header-col col-9">{this.props.texts.consumptionType}</div>
                    </div>
                </div>
                <div className="historic-table-consumptions-widget__table-container">
                    {tableContent}
                </div>
                <div className="page-loader-container">
                    <PageLoader
                        currentPage={this.props.currentPage}
                        totalPages={this.props.totalTablePage}
                        changePage={this.props.changePage}
                        pageText={this.props.texts.page}
                    />
                </div>
            </div>
        );
    }

    private valueToFixedDecimal(value: number, um: string): any {
        if (value) {
            return value.toFixed(1) + " " + um;
        }
        return value;
    }

    private renderItem() {
        const barHeight = 15;

        const tableContent = this.props.tableData.map((value: TableRow, index) => {
            let dispTime = null;
            if (value.dispensingTime) {
                dispTime = value.dispensingTime / 1000;
            }
            return (
                <div className="table-row" key={index}>
                    <div className="col col-1"><p className="value">{moment(value.date).format("D MMM")}</p></div>
                    <div className="col col-1"><p className="value">{moment(value.date).format("HH:mm:ss")}</p></div>
                    <div className="col col-3"><p className="value">{value.dispensingGroup}</p></div>
                    <div className="col col-4">
                        <p className="value">{this.valueToFixedDecimal(dispTime, "s")}</p>
                        <RangeGoodnessElement
                            value={dispTime}
                            min={DispensingAvgTime.min}
                            max={DispensingAvgTime.max}
                            minGood={DispensingAvgTime.minGood}
                            maxGood={DispensingAvgTime.maxGood}
                            width={70}
                            height={barHeight}
                        />
                    </div>
                    <div className="col col-5">
                        <p className="value">{this.valueToFixedDecimal(value.temperature, "°C")}</p>
                        <RangeGoodnessElement
                            value={value.temperature}
                            min={GroupTemperatureAvg.min}
                            max={GroupTemperatureAvg.max}
                            minGood={GroupTemperatureAvg.minGood}
                            maxGood={GroupTemperatureAvg.maxGood}
                            width={70}
                            height={barHeight}
                        />
                    </div>
                    <div className="col col-6">
                        <p className="value">
                            {
                                this.valueToFixedDecimal(
                                    value.boilerServicesPressure ? value.boilerServicesPressure / 1000 : null,
                                    "bar",
                                )
                            }
                        </p>
                        <RangeGoodnessElement
                            value={value.boilerServicesPressure ? value.boilerServicesPressure / 1000 : null}
                            min={BoilerServicesPressureAvg.min}
                            max={BoilerServicesPressureAvg.max}
                            minGood={BoilerServicesPressureAvg.minGood}
                            maxGood={BoilerServicesPressureAvg.maxGood}
                            width={70}
                            height={barHeight}
                        />
                    </div>
                    <div className="col col-7">
                        <p className="value">{this.valueToFixedDecimal(value.waterFlowSpeed, "ml/s")}</p>
                        <RangeGoodnessElement
                            value={value.waterFlowSpeed}
                            min={FluxAvg.min}
                            max={FluxAvg.max}
                            minGood={FluxAvg.minGood}
                            maxGood={FluxAvg.maxGood}
                            width={70}
                            height={barHeight}
                        />
                    </div>
                    <div className="col col-8">
                        <p className="value">{
                            this.valueToFixedDecimal(
                                value.pumpPressure ? value.pumpPressure / 1000 : null,
                                "bar",
                            )
                        }
                        </p>
                        <RangeGoodnessElement
                            value={value.pumpPressure ? value.pumpPressure / 1000 : null}
                            min={PressureAvg.min}
                            max={PressureAvg.max}
                            minGood={PressureAvg.minGood}
                            maxGood={PressureAvg.maxGood}
                            width={70}
                            height={barHeight}
                        />
                    </div>
                    <div className="col col-9">
                        <p className="value">{value.productVariantTypeName}</p>
                    </div>
                </div>
            );
        });
        return (
            <React.Fragment>
                {tableContent}
            </React.Fragment>
        );
    }
}
